import { createSlice } from "@reduxjs/toolkit";
import { updateVisitorDocumentStatus } from "./ApprovalsApi";

const updateVisitorDocumentStatusSlice = createSlice({
    name: "updateVisitorDocumentStatus",
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handle fetchCommunityData cases
            .addCase(updateVisitorDocumentStatus.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateVisitorDocumentStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(updateVisitorDocumentStatus.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default updateVisitorDocumentStatusSlice.reducer;
